module.exports = __webpack_public_path__ + "static/media/zoom-icon.f1a08d6a.svg";